import wAttention from './w-attention.vue';

export const Attention = { install: (app) => app.component(wAttention.name, wAttention) };
export { wAttention };
